import { ENTRY_ORIGIN_VARIANTS, EntryOriginType } from "src/model/shop.model";
import { getCountryLanguage } from "./BasePathTools";
import {
  ROUTE_PATHS,
  ROUTE_ZARA_APPS_PATHS,
  ROUTE_ZARA_WEB_PATHS,
} from "./constants";
import { removeEntryOriginInSession } from "./init/configuration";
import { isApp } from "./utils";
import { getValueCookie } from "./cookies";
import { URL_REDIRECT } from "src/constants/UrlConstants";

export const REDIRECTION_BY_ORIGIN = {
  [ENTRY_ORIGIN_VARIANTS.PROFILE]: ROUTE_ZARA_WEB_PATHS.PROFILE,
  [ENTRY_ORIGIN_VARIANTS.CART]: isApp()
    ? ROUTE_ZARA_APPS_PATHS.CLOSE_CART
    : ROUTE_ZARA_WEB_PATHS.CART,
};

const PATHNAMES_FOR_REDIRECT_ZARA_HOME = [
  `${ROUTE_PATHS.PAYMENT_CONFIRMATION}`,
];

const shouldUseRedirectCookie = (
  redirectCookieValue: string | null,
  isProductPath: boolean,
  isInApp: boolean,
): boolean => {
  return !!(redirectCookieValue?.trim() && isProductPath && !isInApp);
};

export const navigateToZaraHome = (): void => {
  const currentPath = window.location.pathname;
  const redirectCookieValue = getValueCookie(URL_REDIRECT);
  const isProductPath = currentPath.includes(ROUTE_PATHS.PRODUCTS);
  const isInApp = isApp();

  const defaultUrl = `${window.location.origin}${getCountryLanguage()}${ROUTE_ZARA_WEB_PATHS.RECOM_CLOSE}`;

  let urlToNavigate = defaultUrl;

  if (shouldUseRedirectCookie(redirectCookieValue, isProductPath, isInApp)) {
    try {
      urlToNavigate = decodeURIComponent(redirectCookieValue!);
    } catch (error) {
      console.warn("Error decoding redirect URL from cookie:", error);
      urlToNavigate = defaultUrl;
    }
  }

  window.location.href = urlToNavigate;
};

export const handleOriginNavigation = (
  origin: EntryOriginType,
  regularFlowAction: () => void,
  currentPathName: string,
) => {
  if (!!origin) {
    if (
      PATHNAMES_FOR_REDIRECT_ZARA_HOME.some((pathname) =>
        currentPathName.includes(pathname),
      )
    ) {
      removeEntryOriginInSession();
      navigateToZaraHome();
    } else {
      goToZaraSection(REDIRECTION_BY_ORIGIN[origin]);
    }
  } else {
    if (!!regularFlowAction) {
      regularFlowAction();
    }
  }
};

export const goToZaraSection = (section: string) => {
  window.location.replace(`${getCountryLanguage()}${section}`);
};
